st<template>
  <div class="wrapper-card">
    <!----- trust signals strip ----->
    <div class="trust-signals" aria-label="trust">
      <span class="trust-item"><i class="fas fa-lock"></i> תשלום מאובטח SSL</span>
      <span class="trust-item"><i class="fas fa-shield-alt"></i> כרטיסך לא נשמר</span>
    </div>
    <!----- trust signals strip stop ----->

    <div class="price">
      <span class="icon"><img :src="`${speedSizeDomain}/assets/img/after-booking-icon1.png`" alt="after-booking" title="" width="20" height="20"/></span>
      {{ $t("booking.total-to-pay-non-refundable") }} : <strong>{{ price }}</strong>
    </div>
    <div class="border border-light m-auto message-to-visitor p-1 shadow-sm text-center w-100 w-md-50" v-if="messageToVisitor">
     <div>{{ messageToVisitor }}</div>
    </div>

    <!----- payment helper info ----->
    <div class="helper-info">
      <i class="fas fa-info-circle"></i>
      <span>זהו שלב אימות אבטחה. כרטיסך לא יחויב עד שתאשר את ההזמנה הסופית.</span>
    </div>

    <!----- diner notice (softened) ----->
    <p class="diner-notice text-center w-100 mt-3 mb-0"><strong>{{ $t("booking.cant-debit-american-diner") }}</strong></p>

    <iframe id="verifyingCard"
      title="Card Verifiying"
      :src="path1"
      >
    </iframe>

    <!----- cancel / back link ----->
    <div class="cancel-row">
      <a href="#" @click.prevent="goBack" class="cancel-link">
        <i class="fas fa-chevron-right"></i> חזור לפרטי ההזמנה
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import gMixin from '@/utils/mixins';
import googleAnalytics from '@/utils/googleAnalytics';
import imageUrlMixin from '@/utils/imageUrlMixin';

export default {
  mixins: [googleAnalytics, imageUrlMixin, gMixin],
  computed: {
    ...mapGetters({
      path: 'GET_VERIFYING_URL',
      lang: 'GET_LANGUAGE',
      productState: 'GET_PRODUCT',
      isMobileApp: 'GET_STATE_MOBILE_APP',
      isMaccabiAgency: 'GET_IS_MACCABI_AGENCY',
      maccabiUrlPrices: 'GET_MACCABI_VERIFYING_URLS',
    }),
    bookingInfo() {
      return JSON.parse(window.sessionStorage.getItem('BookingDetailInfo')).data;
    },
    price() {
      const price = (this.isMaccabiAgency) ? this.maccabiCurrentPrice : this.bookingInfo.priceNIS;
      return `₪${price}`;
    },
    storageVerifyingUrl() {
      return window.sessionStorage.getItem('VERIFYING_URL');
    },
    storageBookingDataID() {
      return window.sessionStorage.getItem('BookingDataID');
    },
    storageMarketerURL() {
      return window.sessionStorage.getItem('marketerURL');
    },
    maccabiCurrentIndex() {
      const { maccabiUrlPrices } = this;
      return maccabiUrlPrices.currentIndex || 0;
    },
    maccabiCurrentUrl() {
      const { maccabiUrlPrices, maccabiCurrentIndex } = this;
      return maccabiUrlPrices.urls[maccabiCurrentIndex];
    },
    maccabiCurrentPrice() {
      const { maccabiUrlPrices, maccabiCurrentIndex } = this;
      return maccabiUrlPrices.prices[maccabiCurrentIndex];
    },
  },
  data() {
    return {
      path1: '', // "https://www.credit2000.co.il/web_2202/redirect/peleg/credit2000he.aspx?params=400f191a-b140-4514-a4ca-22ab34d2d1e7&css=assets/css/styleVerify.css",
      product: null,
      category: '',
      messageToVisitor: window.sessionStorage.getItem('messageToVisitor') || '',
    };
  },
  created() {
    const localProduction = JSON.parse(
      window.sessionStorage.getItem('production'),
    );
    this.category = this.categoryState || localProduction.category;
    this.product = this.productState || localProduction;

    this.path1 = (this.isMaccabiAgency) ? this.maccabiCurrentUrl : this.path || this.storageVerifyingUrl;

    window.sessionStorage.setItem('VERIFYING_URL', this.path1);

    if (!this.path1.includes('http')) {
      this.sendMailError('*********** VERIFYING URL ***********',
        `path: ${this.path}
        localStoragePath: ${this.storageVerifyingUrl}
        price: ${this.price}`);
    }
  },
  mounted() {
    if (document.querySelector('.st-content')) document.querySelector('.st-content').scrollTo(0, 0);

    if (this.availableEmitEventGA4ByDomain()) {
      let name = '', checkInOut = '', destName = '';
      const currencyCode = this.convertCurrencyCode(this.product.cc);
      const affiliation = this.isMobileApp ? 'BO NAUF' : 'Flying Carpet';
      if (this.category.code === 'Flight_Only') {
        const flight = this.product.flights[0].FlightDetail[0],
          destCode = flight?.FL_To_Route;
        destName = flight?.translations?.flightDestinationName?.[destCode].he || flight?.translations?.flightDestinationName?.[destCode].en;
        name = `${flight.arl_Name} - ${destName}`;
        checkInOut = `${this.product.flights[0].FlightDetail[0].FL_Date} - ${this.product.flights[0].FlightDetail[0].landingDate}`;
      } else {
        const { hotelName } = this.product.hotels[0];
        destName = this.product?.translations?.flightDestinationName?.[this.product?.destination_1]?.he || this.product?.translations?.flightDestinationName?.[this.product?.destination_1]?.en;
        name = `${hotelName} - ${destName}`;
        checkInOut = `${this.bookingInfo?.outwardFlight?.departureDate} - ${this.bookingInfo?.inwardFlight?.departureDate}`;
      }
      this.gtag('event', 'begin_checkout', {
        currency: currencyCode,
        value: this.bookingInfo.price,
        items: [
          {
            item_id: this.storageBookingDataID,
            item_name: name,
            affiliation,
            coupon: '',
            discount: '',
            index: 0,
            item_brand: '',
            item_category: destName,
            item_category2: checkInOut,
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: '',
            item_list_name: '',
            item_variant: '',
            location_id: '',
            price: this.bookingInfo.price,
            quantity: 1,
          },
        ],
      });
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    async sendMailError(pStage, pResponse) {
      const body = `<h3>${pStage}</h3></Br>
        <div><p>${this.storageBookingDataID}</p></div></Br>
        <div><p>${this.storageMarketerURL}</p></div></Br>
        <div><pre>${pResponse}</pre></div>
        `;
      const notification = {
        subject: `${pStage}`,
        body,
      };
      await this.$store.dispatch('NOTIFY_ADMIN', notification);
    },
  },
};
</script>

<style scoped>
  /* ===== Verifying Card layout ===== */
  .wrapper-card{
    margin : auto;
    width: 100%;
    height: 100%;
    padding-top: 16px;
    padding-bottom: 24px;
  }

  /* ===== Trust signals strip (top of payment page) ===== */
  .trust-signals {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 14px;
    padding: 12px 16px;
    margin: 0 12px 20px;
    background: #f7faff;
    border: 1px solid #e1e9f5;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    color: #2d4a6b;
    max-width: 720px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  }
  @media (min-width: 721px) {
    .trust-signals {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .trust-signals .trust-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
  }
  .trust-signals .trust-item i {
    color: #28a745;
    font-size: 14px;
  }

  /* ===== Total price ===== */
  .price{
    font-size: clamp(22px, 5vw, 32px);
    font-weight: 600;
    text-align: center;
    margin: 8px 12px 16px;
    color: #1c4e80;
  }
  .price strong {
    color: #0e436b;
    font-weight: 700;
  }

  .message-to-visitor{
    border-radius: 10px;
  }

  /* ===== Helper info above iframe ===== */
  .helper-info {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    max-width: 720px;
    margin: 12px auto;
    padding: 10px 14px;
    background: #eef6ff;
    border: 1px solid #cfe2ff;
    border-radius: 8px;
    color: #1c4e80;
    font-size: 14px;
    line-height: 1.4;
  }
  .helper-info i {
    color: #1c7ed6;
    font-size: 16px;
    margin-top: 2px;
  }

  /* ===== Diner notice (softened — no longer alarm-red) ===== */
  .diner-notice {
    max-width: 720px;
    margin: 8px auto 16px !important;
    padding: 8px 12px;
    color: #6c4a00;
    background: #fff8e1;
    border: 1px solid #ffe082;
    border-radius: 6px;
    font-size: 13px;
  }
  .diner-notice strong {
    font-weight: 600;
  }

  /* ===== Iframe — responsive height ===== */
  #verifyingCard{
    width: 100%;
    height: calc(100vh - 360px);
    min-height: 520px;
    max-height: 820px;
    border: none;
    display: block;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    .trust-signals {
      font-size: 12px;
      gap: 8px;
      padding: 8px 10px;
    }
    .helper-info {
      font-size: 13px;
      margin: 10px;
    }
    .diner-notice {
      margin: 8px 10px 12px !important;
      font-size: 12px;
    }
    #verifyingCard{
      height: calc(100vh - 420px);
      min-height: 460px;
    }
  }

  /* ===== Cancel / back link ===== */
  .cancel-row {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    padding: 8px;
  }
  .cancel-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #6c757d;
    font-size: 14px;
    text-decoration: none;
    padding: 8px 14px;
    border-radius: 6px;
    transition: background 0.2s ease, color 0.2s ease;
  }
  .cancel-link:hover,
  .cancel-link:focus {
    color: #1c4e80;
    background: #f1f3f5;
    text-decoration: none;
  }
  .cancel-link i {
    font-size: 12px;
  }

</style>

<style>
  #tp_card .tp_input.sc_row {
    width: 100%;
  }
</style>
